export const SET_PRODUCT_COLOUR = 'SET_PRODUCT_COLOUR';
export const SET_PRODUCT_SIZE = 'SET_PRODUCT_SIZE';
export const SET_PRODUCT_LENGTH = 'SET_PRODUCT_LENGTH';
export const SET_FOUNDATION_COLOUR_MATCH = 'SET_FOUNDATION_COLOUR_MATCH';
export const RESET_PRODUCT_SIZE = 'RESET_PRODUCT_SIZE';
export const RESET_PRODUCT_LENGTH = 'RESET_PRODUCT_LENGTH';
export const TOGGLE_SIZE_MODAL = 'TOGGLE_SIZE_MODAL';
export const SET_SELECTION = 'product/SET_SELECTION';
export const SET_PRODUCT_DATA_FORMAT = 'SET_PRODUCT_DATA_FORMAT';
export const SET_RELATED_ITEMS_FETCHED = 'SET_RELATED_ITEMS_FETCHED';
export const SET_TOASTS = 'SET_TOASTS';
export const SET_NAVIGATION_ID = 'SET_NAVIGATION_ID';
